'use client';

import React from 'react';
import { TasticComponentProps} from '../types';
import CategorySpecificData from '@/components/organisms/category-specific';
import usePath from '@/hooks/usePath';
import { CategoryDataItem, Props } from './types';

const CategorySpecific = ({ data }: any) => {
  const categoryData = data?.data?.dataSource;
  const { path } = usePath();
  
  const normalizePath = (p: string) => p?.endsWith('/') && p !== '/' ? p.slice(0, -1) : p;
  const updatedPath = normalizePath(path);
  
  let selectedCategory = null;

  if (Array.isArray(categoryData)) {
    categoryData.forEach((item: CategoryDataItem) => {
      if (normalizePath(item.url) === updatedPath) {
        selectedCategory = item?.sections[0];
      }
    });
  }

  return <CategorySpecificData selectedCategory={selectedCategory} />;
};

export default CategorySpecific;
